import { GraduationCap, Microscope, Briefcase, ShieldCheck, BookOpen, Users, Stethoscope, Award } from "lucide-react";

const ICONS = { GraduationCap, Microscope, Briefcase, ShieldCheck, BookOpen, Users, Stethoscope, Award };

export default function WhyChooseUs({ data }) {
  const items = data?.items || [];
  return (
    <section id="whyChooseUs" data-testid="section-why" className="section-pad bg-[#F0FDFA]">
      <div className="container-pad">
        <div className="max-w-2xl">
          <div className="kicker">{data.kicker || "Why Sunbright"}</div>
          <h2 className="heading-main mt-4">{data.title}</h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, i) => {
            const Icon = ICONS[it.icon] || GraduationCap;
            return (
              <div
                key={i}
                className="bg-white rounded-2xl p-6 border border-teal-100/60 hover:border-teal-300 transition hover:-translate-y-1"
                data-testid={`why-card-${i}`}
              >
                <div className="w-12 h-12 rounded-xl bg-[#1E3A8A]/10 grid place-items-center text-[#1E3A8A]">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="mt-5 text-lg font-bold text-[#0F172A]">{it.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{it.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
